import { Button } from "expano-components";

import { Dashboard } from "components";

import AddSalesPeriodModal from "./components/AddSalesPeriodModal";
import { useState } from "react";
import Item from "./components/Item";

const CpcSalesPeriods = ({ data = [], channel_id, refetch }) => {
  const [is_open_add_period_modal, setAddOpenPeriodModal] = useState(false);

  return (
    <Dashboard
      header={{
        title: "Okresy sprzedaży",
        icon: "info",
        aside: (
          <Button
            type="add"
            text="Dodaj okres"
            onClick={() => setAddOpenPeriodModal(true)}
          />
        ),
      }}
    >
      {is_open_add_period_modal && (
        <AddSalesPeriodModal
          channel_id={channel_id}
          refetch={refetch}
          handleClose={() => setAddOpenPeriodModal(false)}
        />
      )}
      {data?.length > 0 && (
        <div style={{ maxHeight: "530px", overflow: "auto" }}>
          <table className="table">
            <thead
              className="table__head"
              style={{ position: "sticky", top: 0, backgroundColor: "#fff" }}
            >
              <tr>
                <th width="100px">Typ</th>
                <th width="130px">Godz. rozpoczęcia</th>
                <th width="130px">Godz. zakończenia</th>
                <th>Dni tygodnia</th>
                <th width="100px" />
              </tr>
            </thead>
            <tbody className="table__body table-body">
              {data.map((item) => (
                <Item
                  key={item.id}
                  channel_id={channel_id}
                  refetch={refetch}
                  {...item}
                />
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Dashboard>
  );
};

export default CpcSalesPeriods;
